// Note libre d'une pizza (6b.1) — composant présentatif UNIQUE partagé par les
// trois rendus (grande tuile T2, tuiles SUIVANTES, ligne T1) : Cormorant italic,
// ardoise sur crème, SANS ☆ (réservé habitude), rattachée à SA pizza. Troncature
// déterministe locale (ellipse unique `…`) — texte intégral : Loupe. Statique
// (jamais animé), zéro shadcn (rendu sur T2). Aucun hex : tokens palette seulement.
export const NOTE_MAX_TUILE = 80;
export const NOTE_MAX_SUIVANTE = 40;

const ELLIPSE = '…';

function tronquer(texte: string, max: number): string {
  return texte.length <= max ? texte : texte.slice(0, max) + ELLIPSE;
}

interface Props {
  texte: string;
  max: number;
  /** Taille de texte propre au rendu hôte — le style note vit ici, une seule fois. */
  className?: string;
}

export function NotePizza({ texte, max, className }: Props) {
  if (texte.length === 0) return null;
  return (
    <p
      data-testid="note-pizza"
      className={
        'self-start rounded-md bg-creme px-3 py-1 font-cormorant italic text-ardoise' +
        (className ? ` ${className}` : '')
      }
    >
      {tronquer(texte, max)}
    </p>
  );
}
